import axios from 'axios'

const { VUE_APP_BACKEND_URL } = process.env
console.log('Backend url:', VUE_APP_BACKEND_URL)

export default axios.create({
  baseURL: VUE_APP_BACKEND_URL
})
